import dateFormat from 'dateformat';
import {
  ADM, SDM, SDMX, SDMPRO, SY, WL,
  HDA2, HDA3, HDA4, HDA5, HDA6, HDA7,
  HDA8,
} from '@/utils/constants';

export const toFixed = (value, limit = 3) => {
  if (value || value === 0) {
    return Number(value).toFixed(limit);
  }
  return '';
};

export const formatterDate = (value, templ = 'yyyy-mm-dd HH:MM:ss') => {
  try {
    if (value) {
      if (/\d{13}/.test(value)) {
        const date = new Date(+value);
        return dateFormat(date, templ);
      }
      const date = new Date(value);
      return dateFormat(date, templ);
    }
    return '';
  } catch (err) {
    // eslint-disable-next-line
    console.error(`时间格式化错误 ${value} ${err.message}`);
    return '';
  }
};

// 用于计算单点位移
export const formatterDisplacement = (item, device, type) => {
  const { installHeight } = device.devConf || { installHeight: 1 }; // 默认安装高度1米
  const d = item[type] && installHeight ? Math.sin(item[type] * Math.PI / 180) * Number(installHeight) : '';
  return d;
};


// 专用于 element table 组件时间字段格式化
export const tableDateFormatter = (_row, _column, cellValue) => {
  return formatterDate(cellValue);
};

// 专用于 element table 组件数值字段格式化
export const tableToFixedFormatter = (_row, _column, cellValue) => {
  return toFixed(cellValue);
};

// 测斜仪
export const isADM = (device) => {
  return device && device.type === ADM;
};

// 单点位移计
export const isSDM = (device) => {
  return device && device.type === SDM;
};

// 单点振动计
export const isSDMX = (device) => {
  return device && device.type === SDMX;
};

export const isSDMPRO = (device) => {
  return device && device.type === SDMPRO;
};

// 渗压计
export const isHda2 = (device) => {
  return device && device.type === SY;
};

// 水位计
export const isHda3 = (device) => {
  return device && device.type === WL;
};

// 测缝计
export const isHda4 = (device) => {
  return device && device.type === HDA4;
};

// 锚索应力计
export const isHda5 = (device) => {
  return device && device.type === HDA5;
};

// 钢筋计
export const isHda6 = (device) => {
  return device && device.type === HDA6;
};

// 振弦式应变计
export const isHda7 = (device) => {
  return device && device.type === HDA7;
};

// 振弦式轴力计
export const isHda8 = (device) => {
  return device && device.type === HDA8;
};

export const getCookie = (name) => {
  const cookies = {};
  document.cookie.split(';').forEach((segment) => {
    if (segment) {
      const pair = segment.split('=');
      cookies[pair[0].trim()] = pair[1].trim();
    }
  });
  return cookies[name];
};

export const appName = window.location.hostname.split('.')[0];

export const isLocalhost = (/localhost/).test(window.location.hostname);

// 使用内部登录页
export const useInternalLogin = [
  'yskj',
  'demo1', 'demo2', 'demo3', 'demo4', 'demo5', 'demo6', 'demo7', 'demo8', 'demo9', 'demo10',
  'demo11', 'demo12', 'demo13', 'demo14', 'demo15', 'demo16', 'demo17',
].includes(appName) || isLocalhost;

export const useExternalLogin = !useInternalLogin;

// 设备欠压判断
export const isLowVoltage = ({ type, voltage }) => {
  const v = voltage || 0;
  if (type === ADM) return v < 10;
  if (type === HDA2) return v < 3;
  if (type === HDA3) return v < 3;
  return false;
};
